import { Injectable } from '@angular/core';
import { UseService } from '@df/util/service/use.service';

const HIDE_FOOTER_LOCK = 'hide.footer';

@Injectable({
    providedIn: 'root'
})
export class HideFooterService {
    private existingSubscriptions: string[] = [];

    /**
     * Service dependencies
     */
    constructor(private useService: UseService) {}

    /**
     * Add or remove depending on value passed
     */
    hide(source: any) {
        this.useService.lock(HIDE_FOOTER_LOCK, source);
    }

    release(source: any) {
        this.useService.unlock(HIDE_FOOTER_LOCK, source);
    }

    subscribe(cb: (boolean) => void) {
        return this.useService.subscribe(HIDE_FOOTER_LOCK, cb);
    }
}
